export { YandexMetricaProvider } from './components/YandexMetricaProvider';
export { useMetrica } from './hooks/useMetrica';
export { ym } from './lib/ym';
